import React, { useEffect } from 'react'
import { Box, Tabs, Tab, makeStyles, Paper, Button } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import TalkListing from 'views/admin/academics/components/TalkListing'
import { KeyboardArrowRight } from '@mui/icons-material'

const academicsTabs = Object.freeze({
  POSTERS: 'posters',
  TALKS: 'talks'
})

const Academics = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  // Get the search params from the URL
  const searchParams = new URLSearchParams(location.search)
  // Get tab from URL or default to 'posters'
  const tab = searchParams.get('tab') || academicsTabs.TALKS

  // Ensure the tab param exists in URL when component mounts
  useEffect(() => {
    if (!searchParams.has('tab')) {
      const newSearchParams = new URLSearchParams(location.search)
      newSearchParams.set('tab', academicsTabs.TALKS)
      history.replace({
        pathname: location.pathname,
        search: newSearchParams.toString()
      })
    }
  }, [location.search, history, location.pathname, searchParams])

  const handleTabChange = (_, newValue) => {
    const newSearchParams = new URLSearchParams(location.search)
    newSearchParams.set('tab', newValue)
    history.replace({
      pathname: location.pathname,
      search: newSearchParams.toString()
    })
  }

  // The actual filtering is done in TalkListing component, this is just for the tab UI
  return (
    <Box className={classes.container}>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '10px'
        }}>
        <Paper className={classes.tabsContainer}>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            className={classes.tabs}>
            <Tab label="Talks" value={academicsTabs.TALKS} />
            <Tab label="Posters" value={academicsTabs.POSTERS} />
          </Tabs>
        </Paper>

        <Box className={classes.buttonGroupBox}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            endIcon={<KeyboardArrowRight />}
            onClick={() =>
              history.push(
                `/admin/academics/new?type=${tab === academicsTabs.POSTERS ? 'poster' : 'talk'}`
              )
            }>
            Create
          </Button>
        </Box>
      </Box>

      <Box className={classes.contentWrapper}>
        <Paper variant="outlined" style={{ marginTop: '16px' }}>
          {tab === academicsTabs.POSTERS && <TalkListing isPoster={true} />}
          {tab === academicsTabs.TALKS && <TalkListing isPoster={false} />}
        </Paper>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: 'border-box'
  },
  pageTitle: {
    fontWeight: 600,
    fontSize: '26px',
    paddingBottom: theme.spacing(2)
  },
  tabsContainer: {
    borderRadius: 0,
    boxShadow: 'none',
    flexGrow: 1
  },
  tabs: {
    '& .MuiTab-root.MuiTab-labelIcon': {
      minHeight: '35px'
    },
    '& .MuiTab-root .MuiTab-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      alignItems: 'center'
    },
    '& .MuiTab-root.Mui-selected': {
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(51,220,235,0.16)'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.primary.main,
      height: '2px'
    }
  }
}))

export default Academics
